<template>
  <dv-border-box-8 class="order" :dur="4" backgroundColor="rgba(8, 50, 78, 0.6)">
    <PartTitle title="最新订单" />
    <dv-scroll-board class="scroll-board" :config="scrollBoardConfig" />
    <div style="height: 10px"></div>
  </dv-border-box-8>
</template>

<script>
import PartTitle from './PartTitle.vue';

export default {
  name: 'Order',
  components: { PartTitle },
  data() {
    return {
      timerId: null,
      scrollBoardConfig: {
        header: ['名称', '采购地址', '成交金额'],
        data: [
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
          // ['筇竹双层茶棚', '云南', '1400'],
        ],
        rowNum: 8,
        headerBGC: 'none',
        headerHeight: 40,
        oddRowBGC: 'rgba(142,201,255,0.2)',
        evenRowBGC: 'rgba(142,201,255,0.1)',
        index: true,
        waitTime: 2000,
        columnWidth: [50, 180, 120, 100],
        align: ['center', 'center', 'center', 'center'],
      },
    };
  },
  created() {
    this.loadOrderData();
  },
  mounted() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    this.timerId = setInterval(() => {
      this.loadOrderData();
    },1000 * 60 * 5)
  },
  methods: {
    /**
     * 获取指定数量的最新的订单数据
     */
    async loadOrderData() {
      let res = null;
      try {
        res = await this.$http.get('/app-api/order/list/option?count=20')
      } catch (error) {
      }
      if (!res || res.data.length === 0) {
        return;
      }
      const orderData = res.data;
      console.log('订单数据',orderData)
      let newData = [];
      orderData.forEach((order) => {
        newData.push([
          order.orderFormName,
          order.areaName,
          `￥${order.actualMoney}`
        ])
      });
      this.scrollBoardConfig = Object.assign({}, this.scrollBoardConfig, {data: newData})
    },

  },
};
</script>

<style lang="scss" scoped>
.order {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .scroll-board {
    width: 94%;
    height: calc(100% - 60px);
    margin: 0 auto;
  }
}

::v-deep .dv-scroll-board .rows .row-item {
  // margin-bottom: 10px;
  border-radius: 3px;
}
</style>
